import { Organization } from '../global';
import { EXTRNL_REPORT_ORGANIZATION_SEARCH_RESULT, ExternalReportOrganizationData, REPORT_ORGANIZATION_TYPE, REPORT_ORG_INCLUDE_CHILD, RESET_REPORT_FORM, SUBMIT_EXTRNL_REPORT_FORM } from './types';

const initialState = {
  reportOrganizations:[],
  formValues:{},
  isFormSubmitted:false
}
export const reportOrganization = (
  state: ExternalReportOrganizationData = initialState,
  action: {
    type: string;
    payload?: any;
  }
): ExternalReportOrganizationData => {
  switch(action.type) {
    case EXTRNL_REPORT_ORGANIZATION_SEARCH_RESULT :
      return { ...state, reportOrganizations: action.payload };
    case REPORT_ORGANIZATION_TYPE:
      return { ...state, formValues: {...state.formValues, ['organizationType']: action.payload} };
    case REPORT_ORG_INCLUDE_CHILD:
      return { ...state, formValues: {...state.formValues, ['includeChild']: action.payload} };
    case SUBMIT_EXTRNL_REPORT_FORM:
      return { ...state, formValues: {...state,  ...action.payload, ['isFormSubmitted']: true} };
    case RESET_REPORT_FORM:
      return initialState;
    default:
      return state;
  }
}


